import { render } from "./Liquidations25ApprovalHistory.vue?vue&type=template&id=7ae5408c"
import script from "./Liquidations25ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./Liquidations25ApprovalHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__